import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import {translate} from 'admin-on-rest';

const linkToRecord = (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;

const DeleteButton = ({
    basePath = '',
    label = 'aor.action.delete',
    record = {},
    translate,
    customerBaseUrl
}) => (
    <FlatButton
        secondary
        label={label && translate(label)}
        icon={<ActionDelete />}
        containerElement={
            <Link to={`${linkToRecord(customerBaseUrl || basePath, record.id)}/delete`} />
        }
        style={{ overflow: 'inherit' }}
    />
);

DeleteButton.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

export default translate(DeleteButton);



// WEBPACK FOOTER //
// ./src/components/CRM/SuppressionListDeleteButton.js